// import React, { useEffect, useState } from "react";
// import { FaThList, FaInfoCircle } from "react-icons/fa"; // Using 'react-icons' for TabView and DetailView icons
// import DetailsModule from "../../../dca-modules/crud/Details";
// import DetailTabView from "../DetailTabView";
// import { get } from "../../../utils/api";

// const HeaderWithButtons = (props: any) => {
//   const [selectedButton, setSelectedButton] = useState(null);
//   let [ismultiselect, setIsmultiselect] = useState(false);

//   useEffect(() => {
//     getFields();
//   }, [props.module]);

//   const getFields = async () => {
//     try {
//       const response = await get(`${props.module}`, {});
//       console.log("nnnn", response.data.fields)
//       let fieldsWithArrayValues:any[] = [];
//       let fieldsWithoutArrayValues:any[] = [];
//       let fields: any[] = [];

//       if (response.data.fields && response.data.fields.length > 0) {
//         fields=response.data.fields;
//         fields.forEach(field => {
//           if (
//             (field.mapped_collection && field.mapped_collection.multiple === true) ||
//             (field.properties && field.properties.multiple === "true")
//           ) {
//             fieldsWithArrayValues.push(field);
//           } else {
//             fieldsWithoutArrayValues.push(field);
//           }
//         });
//       }
//       console.log("fieldsWithArrayValues", fieldsWithArrayValues)
//       console.log("fieldsWithoutArrayValues", fieldsWithoutArrayValues)
//       if(fieldsWithArrayValues.length > 0){
//         setIsmultiselect(true);
//       }
//       // getData();
//     } catch (error) {
//       console.log("Error fetching fields: ", error);
//     }
//   };

//   const handleButtonClick = (buttonType: any) => {
//     setSelectedButton(buttonType);
//   };

//   return (
//     <>

//     <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
//       {/* Header: 10% height */}
//       <header style={{ height: "10%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", background: "#f4f4f4" }}>
//         <h1>Header Title</h1>
//         <div>
//           <button onClick={() => handleButtonClick("tabView")} style={{ marginRight: "8px", fontSize: "18px", color: "black", background: "none", border: "none" }}>
//             <FaThList />
//           </button>
//           <button onClick={() => handleButtonClick("detailView")} style={{ fontSize: "18px", color: "black", background: "none", border: "none" }}>
//             <FaInfoCircle />
//           </button>
//         </div>
//       </header>

//       {/* Content Area: 90% height */}
//       <div style={{ height: "90%", padding: "16px", background: "#f9f9f9", overflowY: "auto" }}>
//         {selectedButton === "tabView" && (
//           <DetailTabView module={props.module} primary_key={props.primary_key} />
//         )}
//         {selectedButton === "detailView" && (
//           <DetailsModule module={props.module} primary_key={props.primary_key} />
//         )}
//       </div>
//     </div>
//     </>
//   );
// };

// export default HeaderWithButtons;





















import React, { useEffect, useState } from "react";
import { FaThList, FaInfoCircle } from "react-icons/fa"; // Using 'react-icons' for TabView and DetailView icons
import DetailsModule from "../../../dca-modules/crud/Details";
import DetailTabView from "./DetailTabView";
import { get } from "../../../utils/api";
import { Typography } from "@mui/material";
import { startCase } from "lodash";
import { useParams } from 'react-router-dom';
import DetailSubsiderView from "./DetailTabView";


const HeaderWithButtons = (props: any) => {
  const { id } = useParams(); // Fetches the `id` from the route parameters

  const [selectedButton, setSelectedButton] = useState('detailView');
  const [ismultiselect, setIsmultiselect] = useState(false);
  const [arrayWithMultipleProperties, setArrayWithMultipleProperties] = useState<any[]>([])
  const [arrayWithOuthMultipleProperties, setAcrrayWithOuthMultipleProperties] = useState<any[]>([])
  const [items, setItems] = useState<any[]>([])

  useEffect(() => {
    getFields();
  }, [props.module]);

  const getFields = async () => {
    try {
      const response = await get(`${props.module}`, {});
      console.log("nnnn", response.data.fields);
      const fieldsWithArrayValues: any[] = [];
      const fieldsWithoutArrayValues: any[] = [];

      if (response.data.fields && response.data.fields.length > 0) {
        const fields = response.data.fields;
        fields.forEach((field: any) => {
          if (
            (field.mapped_collection && field.mapped_collection.multiple === true) ||
            (field.properties && field.properties.multiple === "true")
          ) {
            fieldsWithArrayValues.push(field);
          } else {
            fieldsWithoutArrayValues.push(field);
          }
        });
      }

      console.log("fieldsWithArrayValues", fieldsWithArrayValues);
      console.log("fieldsWithoutArrayValues", fieldsWithoutArrayValues);
      setArrayWithMultipleProperties(fieldsWithArrayValues);
      setAcrrayWithOuthMultipleProperties(fieldsWithoutArrayValues);
      // Set ismultiselect if there are fields with array values
      if (fieldsWithArrayValues.length > 0) {
        setIsmultiselect(true)
      }
      
    let arr:any= transformarray(fieldsWithArrayValues);
    console.log("arr", arr);
    } catch (error) {
      console.log("Error fetching fields: ", error);
    }
  };
  

  const transformarray = (fieldsWithArrayValues:any) => {
    let transformedArray:any[] = fieldsWithArrayValues.map((item:any) => {
      const key:any = item.key;
      const values:any = item.key
        .split('_')
        .map((word:any) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');     
      return {
        key,
        values,
        component: "RightSideCommonComponent"
      };
    });
    let general={
      key:'general',values:"General", component:"DetailsModule"
    }
    transformedArray.unshift(general)
    setItems(transformedArray)
    return transformedArray;
  }


  const handleButtonClick = (buttonType: any) => {
    setSelectedButton(buttonType);
  };


  return (
    <>
      {!ismultiselect ? (
        // <DetailsModule module={props.module} primary_key={props.primary_key} />
        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
          {/* Header: 10% height */}
          <header
            style={{
              height: "10%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              background: "#f4f4f4",
            }}
          >
            <Typography
              variant="h4"
              sx={{

                fontWeight: "500",
                color: "#333",
                fontSize: "2rem",
                letterSpacing: "0.5px",
                textTransform: "capitalize",
              }}
            >
              {`Details for ${startCase(props.module)}`}
            </Typography>

          </header>

          {/* Content Area: 90% height */}
          <div
            style={{
              height: "90%",
              padding: "16px",
              background: "#f9f9f9",
              overflowY: "auto",
            }}
          >
            <DetailsModule module={props.module} primary_key={props.primary_key} />
          </div>
        </div>
      ) : (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
          {/* Header: 10% height */}
          <header
            style={{
              height: "10%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              background: "#f4f4f4",
            }}
          >
            <Typography
              variant="h4"
              sx={{

                fontWeight: "600",
                color: "#333",
                fontSize: "2.2rem",
                letterSpacing: "0.5px",
                textTransform: "capitalize",
              }}
            >
              {`Details for ${startCase(props.module)}`}
            </Typography>
            <div>
              <button
                onClick={() => handleButtonClick("tabView")}
                style={{
                  marginRight: "8px",
                  fontSize: "18px",
                  color: "black",
                  background: "none",
                  border: "none",
                }}
              >
                <FaThList />
              </button>
              <button
                onClick={() => handleButtonClick("detailView")}
                style={{
                  fontSize: "18px",
                  color: "black",
                  background: "none",
                  border: "none",
                }}
              >
                <FaInfoCircle />
              </button>
            </div>
          </header>

          {/* Content Area: 90% height */}
          <div
            style={{
              height: "90%",
              padding: "16px",
              background: "#f9f9f9",
              overflowY: "auto",
            }}
          >
            {selectedButton === "tabView" && (
              <DetailSubsiderView
              items={items}
              defaultItemKey="general" // Set the default item to render
              module={props.module} // Replace with your actual module
              primary_key={props.primary_key} // Replace with your actual primary key
            />
           )}
            {selectedButton === "detailView" && (
              <DetailsModule module={props.module} primary_key={props.primary_key} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderWithButtons;



